import {
  EntityLinks,
  GoalGroupBy,
  TimelineCategory,
  TimelineDropSlot,
} from '@griply/types';
import { TimelineColumn } from '@griply/utils';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

// A timeline header/background column with its absolute x-offset in the grid,
// so it can be positioned (and virtualized) independently of flex flow.
export type PositionedTimelineColumn = TimelineColumn & { left: number };

export type SideBarItemBase = {
  id: ID;
  // Unique per rendered row — a goal nested under two parents produces two rows that
  // share an `id`. Reconciling those as one component makes the drag preview of one bar
  // render on the other, so React must key on this instead.
  rowKey: string;
  level: number;
  categoryId: ID;
  hasGoals?: boolean;
};

export type SideBarItemGoal = SideBarItemBase & {
  goal: Goal;
};

export type SideBarItemLifeArea = SideBarItemBase & {
  lifeArea: LifeArea;
};

export type SideBarItem = SideBarItemGoal | SideBarItemLifeArea;

// Which row of a goal was picked up, read off the row's path.
export type TimelineDragSource = {
  goalId: ID;
  sourceCategoryId: ID;
  sourceParentGoalId: ID | null;
};

export const getTimelineDragSource = ({
  id,
  rowKey,
}: SideBarItemGoal): TimelineDragSource => {
  const segments = rowKey.split('/');
  return {
    goalId: id,
    sourceCategoryId: segments[0],
    sourceParentGoalId:
      segments.length > 2 ? segments[segments.length - 2] : null,
  };
};

// mirrors @griply/services' ResolveTimelineDropOptions without a ui → services import
export type TimelineReorderDrop = TimelineDragSource & {
  slot: TimelineDropSlot;
  draggedGoalId: ID;
  categories: TimelineCategory[];
  goals: Goal[];
  links: EntityLinks;
  groupBy: GoalGroupBy;
};

export enum TimelineDropAnchors {
  StartAtCursor = 'start-at-cursor',
  Centered = 'centered',
}
